import React from 'react'
import { ThemeProvider } from '@material-ui/core/styles'
import CssBaseline from '@material-ui/core/CssBaseline'
import MuiTheme from 'src/mui/theme'

type Props = {
  children: React.ReactNode
}

export const MuiThemeProvider = ({ children }: Props) => {
  return (
    <ThemeProvider theme={MuiTheme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  )
}
